/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_AgentsInputs */

const en_mk_mx_agents = /** @type {(inputs: Mk_Mx_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents you can create`)
};

const id_mk_mx_agents = /** @type {(inputs: Mk_Mx_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen yang bisa dibuat`)
};

/**
* | output |
* | --- |
* | "Agents you can create" |
*
* @param {Mk_Mx_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_agents = /** @type {((inputs?: Mk_Mx_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_agents(inputs)
	return en_mk_mx_agents(inputs)
});